import React from 'react'
import PropTypes from 'prop-types'

import { Wrapper, Image } from './Actor.styles'

const Actor = ({ name, character, imageUrl }) => {
  return (
    <Wrapper>
      <Image src={imageUrl} />
      <p>{name}</p>
      <p>{character}</p>
    </Wrapper>
  )
}

Actor.propTypes = {
  name: PropTypes.string,
  character: PropTypes.string,
  imageUrl: PropTypes.string,
}
export default Actor
